import { Pagination, TablePagination } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
const EmptyActions = () => null;
const CustomPagination = ({ total, onPageChange, resetPage }) => {
  const { t } = useTranslation();
  const [page, setPage] = useState(1); // 1-based
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const effectiveRowsPerPage = rowsPerPage === -1 ? total : rowsPerPage;
  const pageCount = Math.ceil(total / effectiveRowsPerPage);
  useEffect(() => {
    if ((page - 1) * effectiveRowsPerPage >= total && page > 1) {
      const newPage = page - 1;
      setPage(newPage);
      onPageChange(newPage, effectiveRowsPerPage);
    }
  }, [total, effectiveRowsPerPage, page, onPageChange]);
  useEffect(() => {
    if (resetPage) {
      setPage(1);
      onPageChange(1, effectiveRowsPerPage);
    }
  }, [resetPage]);

  // handle page change 
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    onPageChange(newPage, effectiveRowsPerPage);
  };

  // handle row per page change 
  const handleRowsPerPageChange = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(1);
    onPageChange(1, newRowsPerPage === -1 ? total : newRowsPerPage);
  };

  return (
    <div className="col-lg-12 flex-column flex-md-row d-flex align-items-center justify-content-center custom-pagination">
      <Pagination
        count={pageCount}
        page={page}
        onChange={handlePageChange}
        color="primary"
        sx={{
          "& .Mui-selected": {
            backgroundColor: "#e8671e !important",
            color: "#fff",
          },
        }}
      />

      <TablePagination
        className="row-per-page-pagination"
        rowsPerPageOptions={[10, 25, 50, { label: t("pagination.all"), value: -1 }]}
        component="div"
        count={total}
        rowsPerPage={rowsPerPage}
        page={page - 1}
        onPageChange={(e, newPage) => handlePageChange(e, newPage + 1)}
        onRowsPerPageChange={handleRowsPerPageChange}
        ActionsComponent={EmptyActions}
        labelRowsPerPage={t("pagination.rowsPerPage")}
        labelDisplayedRows={({ from, to, count }) => (
          <div className="mt-3">
            {/* {`${from}–${to} of ${count !== -1 ? count : `more than ${to}`}`} */}
             {count !== -1
              ? t("pagination.displayedRows", { from, to, count })
              : t("pagination.displayedRowsMoreThan", { from, to })}
          </div>
        )}
      />
    </div>
  );
};

export default CustomPagination;


